import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type PwdTheme = 'light' | 'dark';

const STORAGE_KEY = 'pwd-theme';

/**
 * Applies the persisted light/dark preference to the DOM (both the app's own
 * .theme-light class and Bootstrap's data-bs-theme, which must stay in sync —
 * see theme.scss and index.html).
 */
@Injectable({ providedIn: 'root' })
export class ThemeService {
  private themeSubject = new BehaviorSubject<PwdTheme>(this.readStoredTheme());
  readonly theme$ = this.themeSubject.asObservable();

  constructor() {
    this.apply(this.themeSubject.value);
  }

  get theme(): PwdTheme {
    return this.themeSubject.value;
  }

  setTheme(theme: PwdTheme): void {
    localStorage.setItem(STORAGE_KEY, theme);
    this.apply(theme);
    this.themeSubject.next(theme);
  }

  private readStoredTheme(): PwdTheme {
    return localStorage.getItem(STORAGE_KEY) === 'light' ? 'light' : 'dark';
  }

  private apply(theme: PwdTheme): void {
    document.body.classList.toggle('theme-light', theme === 'light');
    document.documentElement.setAttribute('data-bs-theme', theme);
  }
}
